import { render, staticRenderFns } from "./callRemark.vue?vue&type=template&id=5bad7713&scoped=true&"
import script from "./callRemark.vue?vue&type=script&lang=js&"
export * from "./callRemark.vue?vue&type=script&lang=js&"
import style0 from "./callRemark.vue?vue&type=style&index=0&id=5bad7713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad7713",
  null
  
)

export default component.exports